export default __webpack_public_path__ + "static/media/pause-icon.980bc2eb.svg";